(function () {

	'use strict';

	/*global $:true */

	let cologicViewService = {

		initView: function () {

			let that = this;

			this.showToTop();
			// this.setBurger();
			this.bindBurger();
			this.bindContactButton();
			this.enableAccordion();
			this.toggleMenue();
			this.slideLoadedSingle();
			this.setMbVideoHeight();
			// this.navigationHandling();
			// this.setYoutubeBox();
            this.checkVideoPlaySetup();
            this.resetAnimationForIos();
			$('.toTopWrapper').click(this.pageToTop);
			$(window).scroll(function () {
                that.runScrollAnimation();
				that.toggleMenue();
				that.showToTop();
			});
            $(window).on('hashchange', function() {
                that.manageScroll();
            });
            $(window).on('resize', function() {
                that.setMbVideoHeight();
                that.scaleYoutubeBox();
            });
			// setTimeout(function () {
			// 	that.setBackgroundImages()
			// }, 1500);
            that.runScrollAnimation();

			this.equalHeight();
			this.initSlideFunc();
            this.initAnimation();
            this.animateMouseIcon();
            this.configureDate();
            this.setYoutubeBox();
            this.setKontakt();

            this.expandAllDialogTemp();
            // this.enableTagButtonsForDataTags(this.identifyDataTags(['.probo']));
		},

		//--------------------------------------

        resetAnimationForIos: function (){
		    // if(this.isiOS()){
		        $('.teaser-content').removeClass('animated animated-up')
            // }
        },

        isiOS: function () {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        },

		scrollToY: function (_y) {
			$('html, body').animate({scrollTop: _y}, '200');
		},
		scrollToId: function (_id) {
			let offSet = $('.iconContainer').innerHeight();
			// let offSet = $('.header-container').innerHeight();
			// console.log(offSet);
			// console.log($('#' + _id).offset().top - (offSet + 50));
			this.scrollToY($('#' + _id).offset().top - (offSet + 50));
		},

		equalHeight: function () {
			let addedClasses = "";
			let addedClassesCol = "";
			if (arguments[0] !== undefined) addedClasses = arguments[0];
			if (arguments[1] !== undefined) addedClassesCol = arguments[1];

			$('.sameHeightRow .sameHeightCol').css("height", "auto");
			setTimeout(function () {
				$('.sameHeightRow' + addedClasses).each(function () {
					let highestBox = 0;
					$('.sameHeightCol' + addedClassesCol, this).each(function () {
						if ($(this).height() > highestBox) {
							highestBox = $(this).height();
						}
					});
					$('.sameHeightCol' + addedClassesCol, this).height(highestBox);
				});

			}, 100);

		},

        manageScroll: function(){
            let tempHash = window.location.hash;
            if(tempHash!=undefined&&tempHash!=''&&tempHash!=null&&tempHash!=0){
                let offSet = $('.header-container').innerHeight();
                let tempPosition = $(tempHash).offset().top;
                let newPosition = tempPosition - offSet;
                $('html, body').animate({
                    scrollTop:newPosition
                },'slow');

            }

        },

        getURLPath: function(param){
		    let paramVal = false;
		    try {
                if($.QueryString[param]){
                    paramVal = $.QueryString[param];
                }
            }catch (e) {

            }
            return paramVal;
        },

        setMbVideoHeight: function(){
		    $('.v-std').each(function(){
		       $(this).css('height',(($(this).width() / 16) * 9));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    $('.v-qua').each(function(){
		       $(this).css('height', $(this).width() );
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    $('.v-high').each(function(){
                $(this).css('height',(($(this).width() / 9) * 16));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    $('.boxVideo').each(function(){
		       $(this).css('height',(($('.mb-background-video', this).width() / 16) * 8.75));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
        },



        showToTop: function () {
                let slimit = 100;
                let bScroll = Number($("body").scrollTop());
                let hScroll = Number($("html").scrollTop());
                if (hScroll < slimit && bScroll < slimit)
                    $(".toTopWrapper.showDialog").removeClass('showDialog');
                if (hScroll > slimit || bScroll > slimit)
                    $(".toTopWrapper").addClass('showDialog');
        },

        pageToTop() {
            $("html,body").animate({scrollTop: 0}, '500');
        },

		//---------------------------------------------------------
        checkVideoPlaySetup: function(){
            let that = this;
            $('.startVideoInView').each(function(){
               $('.mb-background-video', this).each(function(){
                   $('.innerVideo', this).each(function(){
                       let elem = this;
                       // if(that.isInViewport(elem)){
                       //     $(elem).play();
                       // }else{#
                       // console.log('pause');
                           elem.pause();
                       // $(elem).pause();
                       // }
                       $(elem).attr('controls',false);

                       if(that.isInViewport(elem)){
                           elem.play();
                           $(elem).attr('autoplay',true);
                       }

                       // $(elem).attr('autoplay',true);
                       $(window).scroll(function () {
                           if(that.isInViewport(elem)){
                               elem.play();
                               $(elem).attr('autoplay',true);
                           }
                    });
                   });
               });
           });
            $('.startVideoonClick').each(function(){
                let that = this;
                // if(that.isInViewport(elem)){
                //     elem.play();
                //     $(elem).attr('autoplay',false);
                // }
                $(this).css({'height':(($('.mb-background-video', this).width() / 16) * 10)});
                // $('.innerVideo', this).css({'display':'block'})
                $('.mb-background-video', this).each(function(){
                   $('.innerVideo', this).each(function(){
                       let elem = this;
                       $('.vidBtn', that).on('click', function(){
                           $(elem).parent().css({'z-index':'10', 'overflow-y': 'visible'});
                           $(elem).attr('loop',true);
                           $(elem).attr('controls',true);
                           elem.play();
                           $(this).hide();
                       });
                       // $(window).scroll(function () {
                       //     let result = that.isInViewport(elem);
                       //     // console.log(elem);
                       //     console.log(result);
                       // });
                   });
               });
           });
        },


		// Check if element is scrolled into view
		isInViewport: function (el) {
//             console.log(el);
//
//             // var top = el.offsetTop;
//             var top = $(el).offset().top;
//             var left = $(el).offset().left;
//             // var left = el.offsetLeft;
//             var width = el.offsetWidth;
//             var height = el.offsetHeight;
//
//             // while(el.offsetParent) {
//             //     el = el.offsetParent;
//             //     top += el.offsetTop;
//             //     left += el.offsetLeft;
//             // }
// console.log(top);
// console.log(left);
// console.log(height);
// console.log(width);
// console.log(window.pageYOffset);
// console.log(window.innerHeight);
// console.log(window.pageXOffset);
// console.log(window.innerWidth);
//             return (
//                 top < (window.pageYOffset + window.innerHeight) &&
//                 left < (window.pageXOffset + window.innerWidth) &&
//                 (top + height) > window.pageYOffset &&
//                 (left + width) > window.pageXOffset
//             );


            var top = el.offsetTop;
            var left = el.offsetLeft;
            var width = el.offsetWidth;
            var height = el.offsetHeight;

            while(el.offsetParent) {
                el = el.offsetParent;
                top += el.offsetTop;
                left += el.offsetLeft;
            }

            return (
                top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );



            // const rect = elem.getBoundingClientRect();
            // return (
            //     rect.top >= 0 &&
            //     rect.left >= 0 &&
            //     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            //     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            //
            // );

            // let docViewTop = $(window).scrollTop();
			// let docViewBottom = docViewTop + $(window).height();
            //
			// let elemTop = $(elem).offset().top;
			// let elemBottom = elemTop + $(elem).height();
            //
			// //return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
			// let topInView = ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
			// let bottomInView = ((elemBottom <= docViewBottom) && (elemBottom >= docViewTop));
			// return topInView || bottomInView;
		},

        // setBurger: function () {
        //
        //     // $('#hamburgerIcon').on('click', function(_event){
        //     //     $(this).toggleClass('showMenue').parent().parent().find('.linkElementsWrapper').toggleClass('showMenue');
        //     //     $(this).parent().parent().parent().parent().toggleClass('menueOpen');
        //     // });
        //     //
        //     // $('.linkElements a').on('click', function(_event){
        //     //     $('#hamburgerIcon').click();
        //     // });
        //     $('#hamburgerIcon').on('click', function(_event){
        //         $(this).toggleClass('showMenue').parent().parent().find('.linkElementsWrapper').toggleClass('showMenue');
        //         $(this).parent().parent().parent().parent().toggleClass('menueOpen');
        //     })
        //
        // },

        bindBurger: function() {
            let that = this;
            let mainMenu =  $('#headerMain');
            $('#hamburgerIcon').on('click', function(){
                console.log('click');
                that.toggleMenu(mainMenu)
            });
        },


        bindContactButton: function() {
            let that = this;
            let cbtn = document.querySelectorAll('.btnContact');
            let mainMenu =  document.querySelector('#headerMain');
            if (typeof(cbtn) != 'undefined' && cbtn != null){
                cbtn.forEach((item)=>{
                    item.addEventListener("click", ()=>{
                        that.toggleMenu(mainMenu)
                    });
                });
            }
        },

        showCrInfo: function(_elem){
            $(_elem).parent().click(function(e) {
                e.preventDefault();
            });
            // let curhref = window.location.href;
            $(_elem).find('p').toggleClass('showInfo');
            setTimeout(function (){
                $(_elem).parent().unbind('click');
            },1000);
        },


        // toggleMenu: function(menu) {
        //     if (menu.classList.contains("open")) {
        //         menu.classList.remove("open");
        //
        //         let scrollY = document.body.style.top;
        //         document.body.style.position = '';
        //         document.body.style.top = '';
        //         window.scrollTo(0, parseInt(scrollY || '0') * -1);
        //     } else {
        //         menu.classList.add("open");
        //
        //         // When the modal is shown, we want a fixed body
        //         document.body.style.top = -1 * window.scrollY+"px";
        //         document.body.style.position = 'fixed';
        //     }
        // },

        trackMenuPosition: function() {
            let slimit=100;
            let bScroll=Number($("body").scrollTop());
            let hScroll=Number($("html").scrollTop());
            if(hScroll<slimit && bScroll<slimit)
                $('#headerMain').removeClass('scrolled');
            if(hScroll>slimit || bScroll>slimit)
                $('#headerMain').addClass('scrolled');
        },


    toggleMenu: function (menu = $('#headerMain')) {



            // // let slimit=100;
            // // let bScroll=Number($("body").scrollTop());
            // // let hScroll=Number($("html").scrollTop());
            // // if(hScroll<slimit && bScroll<slimit)
            // //     $('#header').removeClass('headerStick');
            // // if(hScroll>slimit || bScroll>slimit)
            // //     $('#header').addClass('headerStick');
            //
            //
            // let slimit=100;
            // let bScroll=Number($("body").scrollTop());
            // let hScroll=Number($("html").scrollTop());
            // if(hScroll<slimit && bScroll<slimit)
            //     $('#header').removeClass('headerStick');
            // if(hScroll>slimit || bScroll>slimit)
            //     $('#header').addClass('headerStick');

            if ($(menu).hasClass('open')) {
                $(menu).removeClass('open');

                let scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            } else {
                // menu.classList.add("open");
                $(menu).addClass('open');

                // When the modal is shown, we want a fixed body
                document.body.style.top = -1 * window.scrollY+"px";
                document.body.style.position = 'fixed';
            }

        },


        toggleMenue: function (menu) {


            // let slimit=100;
            // let bScroll=Number($("body").scrollTop());
            // let hScroll=Number($("html").scrollTop());
            // if(hScroll<slimit && bScroll<slimit)
            //     $('#header').removeClass('headerStick');
            // if(hScroll>slimit || bScroll>slimit)
            //     $('#header').addClass('headerStick');


            let slimit=100;
            let bScroll=Number($("body").scrollTop());
            let hScroll=Number($("html").scrollTop());
            if(hScroll<slimit && bScroll<slimit)
                $('#headerMain').removeClass('headerStick');
                // $('#headerMain').removeClass('headerStick');
            if(hScroll>slimit || bScroll>slimit)
                $('#headerMain').addClass('headerStick');
                // $('#headerMain').addClass('headerStick');


        },



        setYoutubeBox: function () {
			$('.mubo-b-1').each(function () {

                let parent_h = (($(this).width() / 16) * 9);
                let parent_w = $(this).width();
				if ($('.videoLinkEl', this).length > 0) {
					let srcVal = $('.videoLinkEl', this).data('src-value');
					let ytSrcFind;
					if (srcVal.indexOf('youtu.be') !== -1) {
						ytSrcFind = srcVal.lastIndexOf('/');
					} else {
						ytSrcFind = srcVal.lastIndexOf('=');
					}
					let ytSrcClean = srcVal.slice(ytSrcFind + 1);
					// $('.videoLinkEl', this).find('iframe').attr('src', 'https://www.youtube.com/embed/' + ytSrcClean + '?autoplay=0&mute=1');  //.attr('autoplay','1').get(0).click();
					$('.videoLinkEl', this).find('iframe').attr('src', 'https://www.youtube.com/embed/' + ytSrcClean + '?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0').attr('width', parent_w).attr('height', parent_h);  //.attr('autoplay','1').get(0).click();
					// $('.videoLinkEl', this).find('iframe').attr('src', 'https://www.youtube.com/embed' + ytSrcClean + '?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0');  //.attr('autoplay','1').get(0).click();
				}
			});



        },

        scaleYoutubeBox: function () {
			$('.mubo-b-1').each(function () {

                let parent_h = (($(this).width() / 16) * 9);
                let parent_w = $(this).width();
				if ($('.videoLinkEl', this).length > 0) {
					$('.videoLinkEl', this).find('iframe').attr('width', parent_w).attr('height', parent_h);
				}
			});


        },



        enableAccordion: function(_el){

            //multibox
            $('.acboInnerContent').each(function () {
                    $('.acbo-element', this).accordion({
                        animate: 300,
                        header: '.acbo-subHead',
                        // header: 'h3',
                        collapsible: true,
                        heightStyle: 'content',
                        active: true
                    });
            });

            $('.event .inboInnerRight').each(function () {
                    $('.inboInnerRightBox2', this).accordion({
                        animate: 300,
                        header: '.inboInnerRightBox2Head',
                        // header: 'h3',
                        collapsible: true,
                        heightStyle: 'content',
                        active: true
                    });
            });


            $('.inboAcc').each(function () {
                    $(this).accordion({
                        animate: 300,
                        header: '.infosec-head',
                        // header: 'h3',
                        collapsible: true,
                        heightStyle: 'content',
                        active: true
                    });
            });



		},

        configureDate: function(){

            //multibox
            // $('.inboImage .inbo-start-s').each(function () {
            $('.inboInnerRightBox .inbo-start-s').each(function () {
                    $('.inbo-termin-s', this).each(function () {
                        let tempDate = $(this).data('termin');
                        if(Date.now() > tempDate){
                            $(this).addClass('inactive')
                        }
                    });
            });



		},

		removeOverlay: function(_el){
			$(_el).hide().parent().find('video').get(0).play();
		},

        slideLoadedSingle: function(){
                let _vid = $('.innerVideo');
                if(_vid.length > 0){
                    var mediaVideo = _vid.get(0);
                    // setTimeout(function(){
                        _vid.parent().css('z-index','-1');
                        _vid.parent().css('display','flex');
                        _vid.parent().parent().find('.mubo-bg').remove();
                        mediaVideo.play();
                    // },1500);


            }


		},
        showMenu: function() {
            //$("#menuContent").show();
            $("body").addClass("menu-open");
        },

        closeMenu: function() {
            //$("#menuContent").hide();
            $("body").removeClass("menu-open");
        },

        //------------------------------------------------------------

        // Check if element is scrolled into view
        isScrolledIntoView: function(elem) {
            let docViewTop = $(window).scrollTop();
            let docViewBottom = docViewTop + $(window).height();

            let elemTop = $(elem).offset().top;
            let elemBottom = elemTop + $(elem).height();

            //return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
            let topInView = ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
            let bottomInView = ((elemBottom <= docViewBottom) && (elemBottom >= docViewTop));
            return topInView || bottomInView;
        },

        //Trigger Animation
        //animateCss($(".personBox"), "shakeX");
        animateCss: function(el, animationName) {

            let animationPrefix = "";//animate__
            //als Promise benachrichtigen, wenn fertig
            return new Promise((resolve, reject) => {
                //gleichzeitig auf Ende horchen und aufräumen
                el.addClass(animationPrefix + 'animated ' + animationPrefix + animationName).one('animationend', function () {
                    el.removeClass(animationPrefix + 'animated ' + animationName);
                    //fertig
                    resolve();
                });
            });
        },

        //scroll-basierte Animationen triggern
        runScrollAnimation: function() {
            let that = this;
            $('.scroll-animations .animated').each(function () {
                if (that.isScrolledIntoView(this) === true) {

                    let thisEl = $(this);

                    if (thisEl.hasClass("animated-left")) {
                        thisEl.addClass('fadeInLeft ');
                    }
                    if (thisEl.hasClass("animated-up")) {
                        thisEl.addClass('fadeInUp ');
                    }
                    if (thisEl.hasClass("animated-right")) {
                        thisEl.addClass('fadeInRight');
                    }
                    if (thisEl.hasClass("animated-fadeIn")) {
                        thisEl.addClass('fadeIn');
                    }
                    if (thisEl.hasClass("animated-zoom")) {
                        thisEl.addClass('zoomIn');
                        setTimeout(function () {
                            thisEl.removeClass('animated-zoom zoomIn');
                        }, 1000);
                    }
                }
                else{

                    //Reset oben /NOT: und unten
                    let scrollTop = $(window).scrollTop();
                    let scrollHeight = $(document).height();
                    let scrollPosition = $(window).height() + $(window).scrollTop();
                    if ((scrollTop === 0) /*|| ((scrollHeight - scrollPosition) / scrollHeight === 0)*/) {
                        $(this).removeClass('fadeInLeft fadeInUp fadeInRight fadeIn');
                    }
                }
            });
        },

        expandAllDialogTemp: function(){

            // Gespeicherte Daten aus dem sessionStorage abfragen
            if (!sessionStorage.getItem("dialogblogseen")) {
                $('.newsletterWrapper').each(function () {
                    $(this).addClass('largeWrapper');
                    sessionStorage.setItem('dialogblogseen', '1');
                    let that = $(this);
                    setTimeout(function () {
                        $(that).removeClass('largeWrapper');
                    }, 10000);
                });
            }
        }




};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicViewService);
}());